// import React, { useMemo } from "react";
// import { useSelector } from "react-redux";
// import { useTabNavigation } from "../../helpers/useTabNavigation";
// import { LayoutDashboard, BarChart3, Megaphone, CheckSquare, ClipboardCheck } from 'lucide-react';
// import AttendanceDashboard from "./AttendanceDashboard"; 
// import AttendanceRegularization from "../../components/HRComponents/AttendanceRegularization";
// import MyPermissionsAndCompOffs from "../../components/HRComponents/MyPermissionsAndCompOffs";
// import PermissionAndCompApproval from "../../components/HRComponents/PermissionAndCompApproval";

// const HROverviewTabs = () => {
//   const user = useSelector((state) => state?.user?.user);

//   const tabs = useMemo(() => [
//     {
//       id: 'overview',
//       label: 'Overview',
//       icon: <LayoutDashboard className="h-4 w-4" />,
//       description: 'Complete HR Attendance & Overview Dashboard',
//       content: <AttendanceDashboard user={user} />
//     },
//     {
//       id: 'regularizations',
//       label: 'Regularizations',
//       icon: <ClipboardCheck className="h-4 w-4" />,
//       description: 'Attendance Regularization Requests (Upcoming)',
//       content: <AttendanceRegularization user={user} />
//     },
//     {
//       id: 'permissions',
//       label: 'Permissions',
//       icon: <ClipboardCheck className="h-4 w-4" />,
//       description: 'Attendance Regularization Requests (Upcoming)',
//       content: <MyPermissionsAndCompOffs user={user} />
//     },
//     {
//       id: 'CompOffs Approval',
//       label: 'comp-offs',
//       icon: <ClipboardCheck className="h-4 w-4" />,
//       description: 'Attendance Regularization Requests (Upcoming)',
//       content: <PermissionAndCompApproval user={user} />
//     },
//     {
//       id: 'analytics',
//       label: 'Analytics',
//       icon: <BarChart3 className="h-4 w-4" />,
//       description: 'Advanced Workforce Analytics (Upcoming)',
//       content: (
//         <div className="flex flex-col items-center justify-center min-h-[450px] bg-white rounded-[2.5rem] shadow-sm border border-gray-100">
//           <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-4">
//              <BarChart3 size={32} className="text-primary opacity-40" />
//           </div>
//           <h2 className="text-lg font-bold text-gray-800 uppercase tracking-widest">Analytics Coming Soon</h2>
//           <p className="text-gray-400 text-xs font-medium">We are preparing detailed insights for your organization.</p>
//         </div>
//       )
//     },
//     {
//       id: 'announcements',
//       label: 'Announcements',
//       icon: <Megaphone className="h-4 w-4" />,
//       description: 'Company Updates & Announcements',
//       content: (
//         <div className="flex flex-col items-center justify-center min-h-[450px] bg-white rounded-[2.5rem] shadow-sm border border-gray-100">
//           <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-4">
//              <Megaphone size={32} className="text-primary opacity-40" />
//           </div>
//           <h2 className="text-lg font-bold text-gray-800 uppercase tracking-widest">No Announcements</h2>
//           <p className="text-gray-400 text-xs font-medium">There are no new updates at this moment.</p>
//         </div>
//       )
//     },
//     {
//       id: 'tasks',
//       label: 'Tasks',
//       icon: <CheckSquare className="h-4 w-4" />,
//       description: 'HR Administrative Tasks List',
//       content: (
//         <div className="flex flex-col items-center justify-center min-h-[450px] bg-white rounded-[2.5rem] shadow-sm border border-gray-100">
//           <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-4">
//              <CheckSquare size={32} className="text-primary opacity-40" />
//           </div>
//           <h2 className="text-lg font-bold text-gray-800 uppercase tracking-widest">Tasks Empty</h2>
//           <p className="text-gray-400 text-xs font-medium">You have no pending tasks to complete.</p>
//         </div>
//       )
//     }
//   ], [user]);

//   // Tab Navigation Hook
//   const { activeTab, changeTab } = useTabNavigation(tabs);
  
//   const activeTabData = tabs.find(tab => tab.id === activeTab);

//   return (
//     <div className="bg-gray-50">
//       {/* --- TOP TAB NAVIGATION (Home Page Style - Red Background) --- */}
//       <div className="bg-primary shadow-md sticky top-0 z-50">
//         <div className="mx-auto">
//           <div className="px-4 lg:px-6">
//             <div className="flex items-center justify-between">
//               {/* Folder Style Tabs */}
//               <nav className="flex space-x-2 overflow-x-auto custom-scrollbar pt-2" aria-label="Tabs">
//                 {tabs.map((tab) => {
//                   const isActive = activeTab === tab.id;
                  
//                   return (
//                     <button
//                       key={tab.id}
//                       onClick={() => changeTab(tab.id)}
//                       className={`
//                         group inline-flex items-center py-3 px-6 font-bold text-[11px] uppercase tracking-[0.1em]
//                         whitespace-nowrap transition-all duration-300 ease-in-out
//                         ${isActive
//                           ? 'bg-white text-primary rounded-t-xl transform -translate-y-px shadow-sm'
//                           : 'text-red-100 hover:text-white hover:bg-red-700 rounded-t-xl'
//                         }
//                       `}
//                       aria-current={isActive ? 'page' : undefined}
//                     >
//                       <span className="mr-2 opacity-70">{tab.icon}</span>
//                       <span>{tab.label}</span>
//                     </button>
//                   );
//                 })}
//               </nav>

//               {/* Active Tab Description */}
//               <div className="hidden lg:block text-[10px] font-bold text-red-100 uppercase tracking-widest opacity-80 italic">
//                 {activeTabData?.description}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* --- CONTENT AREA --- */}
//       <div className="mx-auto px-4 lg:px-6 py-6">
//         <div className="max-w-[1600px] mx-auto animate-in fade-in duration-500">
//           {activeTabData?.content}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HROverviewTabs;

// ─────────────────────────────────────────────────────────────────────────────
// FILE: src/components/HRComponents/HROverviewTabs.jsx
// ─────────────────────────────────────────────────────────────────────────────
import React, { useMemo } from "react";
import { useTabNavigation } from "../../helpers/useTabNavigation";
import { LayoutDashboard, BarChart3, Megaphone, CheckSquare, ClipboardCheck } from 'lucide-react';
import AttendanceDashboard from "./AttendanceDashboard"; 
import AttendanceRegularization from "../../components/HRComponents/AttendanceRegularization";
import MyPermissionsAndCompOffs from "../../components/HRComponents/MyPermissionsAndCompOffs";
import PermissionAndCompApproval from "../../components/HRComponents/PermissionAndCompApproval"; // 👈 இம்போர்ட் செய்யப்பட்டுள்ளது
import { usePermission } from "../../hooks/usePermission"; 
import AllPermissionsAndCompOffsList from "../../components/HRComponents/AllPermissionsAndCompOffsList";
import AttendanceCalendar from "../../components/HRComponents/AttendanceCalendar";
import AllRegularizationList from "../../components/HRComponents/AllRegularizationList";

const HROverviewTabs = () => {
  const { hasPermission, user } = usePermission();

  const tabs = useMemo(() => {
    // 1. அனைத்து பயனர்களுக்கும் தெரிய வேண்டிய அடிப்படை டேப்கள்
    const allTabs = [
      {
        id: 'overview',
        label: 'Overview',
        icon: <LayoutDashboard className="h-4 w-4" />,
        // description: 'Complete HR Attendance & Overview Dashboard',
        content: <AttendanceDashboard user={user} />
      },
      {
        id: 'my-calendar',
        label: 'My Calendar',
        icon: <ClipboardCheck className="h-4 w-4" />,
        // description: 'Attendance Regularization Requests',
        content: <AttendanceCalendar user={user} />
      },
      {
        id: 'regularizations',
        label: 'Regularizations',
        icon: <ClipboardCheck className="h-4 w-4" />,
        // description: 'Attendance Regularization Requests',
        content: <AttendanceRegularization user={user} />
      },
      {
        id: 'permissions',
        label: 'Permissions',
        icon: <ClipboardCheck className="h-4 w-4" />,
        // description: 'My Permission & Comp-Off Requests',
        content: <MyPermissionsAndCompOffs user={user} />
      },
      {
        id: 'analytics',
        label: 'Analytics',
        icon: <BarChart3 className="h-4 w-4" />,
        // description: 'Advanced Workforce Analytics (Upcoming)',
        content: (
          <div className="flex flex-col items-center justify-center min-h-[450px] bg-white rounded-[2.5rem] shadow-sm border border-gray-100">
            <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-4">
               <BarChart3 size={32} className="text-primary opacity-40" />
            </div>
            <h2 className="text-lg font-bold text-gray-800 uppercase tracking-widest">Analytics Coming Soon</h2>
            <p className="text-gray-400 text-xs font-medium">We are preparing detailed insights for your organization.</p>
          </div>
        )
      },
      {
        id: 'announcements',
        label: 'Announcements',
        icon: <Megaphone className="h-4 w-4" />,
        // description: 'Company Updates & Announcements',
        content: (
          <div className="flex flex-col items-center justify-center min-h-[450px] bg-white rounded-[2.5rem] shadow-sm border border-gray-100">
            <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-4">
               <Megaphone size={32} className="text-primary opacity-40" />
            </div>
            <h2 className="text-lg font-bold text-gray-800 uppercase tracking-widest">No Announcements</h2>
            <p className="text-gray-400 text-xs font-medium">There are no new updates at this moment.</p>
          </div>
        )
      },
      {
        id: 'tasks',
        label: 'Tasks',
        icon: <CheckSquare className="h-4 w-4" />,
        // description: 'HR Administrative Tasks List',
        content: (
          <div className="flex flex-col items-center justify-center min-h-[450px] bg-white rounded-[2.5rem] shadow-sm border border-gray-100">
            <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-4">
               <CheckSquare size={32} className="text-primary opacity-40" />
            </div>
            <h2 className="text-lg font-bold text-gray-800 uppercase tracking-widest">Tasks Empty</h2>
            <p className="text-gray-400 text-xs font-medium">You have no pending tasks to complete.</p>
          </div>
        )
      },

    ];

    // 2. HR 
    const adminTabs = [
      {
        id: 'comp-off-approval',
        label: 'CompOffs Approval', // 👈 'comp-offs' என்பதில் இருந்து 'Approvals' என்று மாற்றப்பட்டுள்ளது
        icon: <ClipboardCheck className="h-4 w-4" />,
        // description: 'Permission & Comp-Off Requests Approval Workflow',
        content: <PermissionAndCompApproval user={user} />,  
        permissionKey: "hr:comp-off-approval", 
        action: "view"
      },
      {
        id: 'all-comp-off-approval',
        label: 'All CompOffs Approval',
        icon: <ClipboardCheck className="h-4 w-4" />,
        // description: 'Permission & Comp-Off Requests Approval Workflow',
        content: <AllPermissionsAndCompOffsList user={user} />, 
        permissionKey: "hr:all-comp-off-approval", 
        action: "view"
      },
      {
        id: 'all-regularize-approval',
        label: 'All Regularizations Approval', 
        icon: <ClipboardCheck className="h-4 w-4" />,
        // description: 'Permission & Comp-Off Requests Approval Workflow',
        content: <AllRegularizationList user={user} />,
        permissionKey: "hr:all-regularize-approval", 
        action: "view"
      }
    ];

    adminTabs.forEach(tab => {
      if (hasPermission(tab.permissionKey, tab.action)) {
        allTabs.push(tab);
      }
    });

    return allTabs;
  }, [user, hasPermission]);

  const { activeTab, changeTab } = useTabNavigation(tabs, 'overview');
  
  const activeTabData = tabs.find(tab => tab.id === activeTab) || tabs[0];

  return (
    <div className="bg-gray-50">
      {/* --- TOP TAB NAVIGATION --- */}
      <div className="bg-primary shadow-md sticky top-0 z-20">
        <div className="mx-auto">
          <div className="px-4 lg:px-6">
            <div className="flex items-center justify-between">
              <nav className="flex space-x-2 overflow-x-auto custom-scrollbar pt-2" aria-label="Tabs">
                {tabs.map((tab) => {
                  const isActive = activeTab === tab.id;
                  
                  return (
                    <button
                      key={tab.id}
                      onClick={() => changeTab(tab.id)}
                      className={`
                        group inline-flex items-center py-3 px-6 font-bold text-[11px] uppercase tracking-[0.1em]
                        whitespace-nowrap transition-all duration-300 ease-in-out
                        ${isActive
                          ? 'bg-white text-primary rounded-t-xl transform -translate-y-px shadow-sm'
                          : 'text-red-100 hover:text-white hover:bg-red-700 rounded-t-xl'
                        }
                      `}
                      aria-current={isActive ? 'page' : undefined}
                    >
                      <span className="mr-2 opacity-70">{tab.icon}</span>
                      <span>{tab.label}</span>
                    </button>
                  );
                })}
              </nav>

              <div className="hidden lg:block text-[10px] font-bold text-red-100 uppercase tracking-widest opacity-80 italic">
                {activeTabData?.description}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- CONTENT AREA --- */}
      <div className="mx-auto px-4 py-6">
        <div className="animate-in fade-in duration-500">
          {activeTabData?.content}
        </div>
      </div>
    </div>
  );
};

export default HROverviewTabs;